import { Fragment } from 'react';

import { useLocalization } from 'redux/localization/utils/hooks';

const GiftCardItemData = (props) => {
  const { item } = props;
  const { t } = useLocalization();

  if (item.type !== 'Gift Card') {
    return null;
  }
  if (!item.itemData) {
    return null;
  }
  if (!item.itemData.recipients) {
    return null;
  }
  if (item.itemData.recipients.length === 1) {
    const recipient = item.itemData.recipients[0];
    return (
      <>
        <div className="c7-break" />
        <div className="c7-order-item--giftcard__details">
          <p>
            {t('general.giftCard.recipient')}: {recipient.email}
          </p>
          {recipient.giftMessage && (
            <p className="c7-alt-text">
              {t('general.giftCard.message')}: &quot;{recipient.giftMessage}
              &quot;
            </p>
          )}
        </div>
      </>
    );
  }
  return (
    <>
      <div className="c7-break" />
      {item.itemData.recipients.map((recipient, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <div className="c7-break" />
          <div className="c7-order-item--giftcard__details">
            <p>To: {recipient.email}</p>
            {recipient.giftMessage && (
              <p className="c7-alt-text">
                {t('general.giftCard.message')}: &quot;{recipient.giftMessage}
                &quot;
              </p>
            )}
          </div>
        </Fragment>
      ))}
    </>
  );
};

export default GiftCardItemData;
